import { createRouter, createWebHashHistory } from 'vue-router'
import { useSystemConfigStore } from '@/stores/systemConfig'
import AES from '@/utils/aes'
import { getAllinfo } from '@/api/user'

import Home from '@/views/Home/index.vue'
import Price from '@/views/Price/index.vue'
import Case from '@/views/Case/index.vue'
import About from '@/views/About/index.vue'
import MHome from '@/views/Home/MHome.vue'
import MPrice from '@/views/Price/MPrice.vue'
import MCase from '@/views/Case/MCase.vue'
import MAbout from '@/views/About/MAbout.vue'
import Index from '@/views/Index/index.vue'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/home',
      name: 'Web',
      component: Index,
      children: [
        {
          path: '/home',
          name: 'Home',
          component: Home,
        },
        {
          path: '/price',
          name: 'Price',
          component: Price,
        },
        {
          path: '/about',
          name: 'About',
          component: About,
        },
        {
          path: '/case',
          name: 'Case',
          component: Case,
        },
      ],
    },
    {
      path: '/mobile',
      redirect: '/mobile/home',
      name: 'Mobile',
      component: Index,
      children: [
        {
          path: '/mobile/home',
          name: 'MobileHome',
          component: MHome,
        },
        {
          path: '/mobile/price',
          name: 'MobilePrice',
          component: MPrice,
        },
        {
          path: '/mobile/about',
          name: 'MobileAbout',
          component: MAbout,
        },
        {
          path: '/mobile/case',
          name: 'MobileCase',
          component: MCase,
        },
      ],
    },
  ],
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

async function getAppConfig() {
  useSystemConfigStore().baseUrl = []
  return new Promise((resolve, reject) => {
    getAllinfo()
      .then(({ success, resultMap }) => {
        if (success) {
          const dess = JSON.parse(AES.decrypt(resultMap, '6plwu888B@M1x917'))
          useSystemConfigStore().setData({
            baseUrl: dess,
          })
          return resolve({ success, resultMap })
        } else {
          return Promise.reject()
        }
      })
      .catch((err) => {
        console.log(err, 'err')
        setTimeout(() => {
          getAppConfig()
        }, 1000)
      })
  })
}

let firstEnterFlag = true
router.beforeEach(async (to, from, next) => {
  firstEnterFlag && (await getAppConfig())
  firstEnterFlag = false
  next()
})

export default router
